import wxBridge from '../jsbridge/jsbridge_base.js';

wxBridge.openFinderTopicView = wxBridge.openFinderTopicView || function (param, callback) {
    param.entryScene = 9;
    if( param.topicType ) {
        param.topicType = Number(param.topicType)
    }
    wxBridge.invoke('openFinderTopicView', {
        extInfo: JSON.stringify(param)
    }, callback);
};

export default wxBridge;

export const {
    openFinderTopicView
} = wxBridge;
